export default {
  install(Vue) {
    Vue.prototype.$t = function (key, replacements = {}) {
      let translation =
        window.translations && window.translations[key]
          ? window.translations[key]
          : key;

      if (typeof replacements === "object" && replacements !== null) {
        Object.keys(replacements).forEach((param) => {
          const regex = new RegExp(`:${param}`, "g");
          translation = translation.replace(regex, replacements[param]);
        });
      }

      return translation;
    };
  },
};
